import { render, staticRenderFns } from "./ApprovedOffMfa.vue?vue&type=template&id=b68adfe4"
import script from "./ApprovedOffMfa.vue?vue&type=script&lang=js"
export * from "./ApprovedOffMfa.vue?vue&type=script&lang=js"
import style0 from "./ApprovedOffMfa.vue?vue&type=style&index=0&id=b68adfe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
